module.exports = __webpack_public_path__ + "static/rhubarb-b89ae8e4bc4e13eb63673f4aff9d8456.svg";